import { navigate } from "svelte-routing";

export const basepath = "/kummirube";

export function appPath(path: string): string {
    if (path === "/") return `${basepath}/`;

    return `${basepath}${path}`;
}

export function navigateTo(path: string): void {
    navigate(appPath(path));
}
